import { Component, Injector, Input } from '@angular/core';
import { BaseView } from '../../../../submodules/angular-ui-common/base-view';
import { CanvasLayoutDataService } from '../../../../submodules/angular-common/canvas-layout-data.service';
import { RoutingDataService } from '../../../../submodules/angular-common/routing-data.service';
import { PageLayoutDataService } from '../../../angular-common/page-layout-data.service';

/**
 * Layout di base applicabile ad una page. 
 * Una page è una view che occupa l'intera area disponibile al netto delle side-nav, dell'header e dell'eventuale footer 
 * (il footer generalmente fa parte della page)
 */
@Component({ 
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent extends BaseView {

  unsupportedResolution: boolean = false;

  constructor(
    public routingDataService: RoutingDataService,
    public pageLayoutDataService: PageLayoutDataService,
    public canvasLayoutDataService: CanvasLayoutDataService,
    protected _injector: Injector
  ) {
    super(_injector)
  }
}
